import { AtticusForm } from "models/AtticusForm";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  CONSTANTS as SHARED_CONSTANTS,
} from "@theatticusapp/atticus-shared-components";
import { downloadAtticusForm } from "utils/download";

export enum PdfFileChoice {
  PROCESSED = "processed",
  WATERMARKED = "watermarked",
  THUMBNAIL = "thumbnail",
}

/**
 * Hook that allows a component to view a form PDF file and download it.
 * @param args
 * @returns
 */
export const useAtticusFormViewer = (args: {
  form?: AtticusForm;
  fileChoice: PdfFileChoice;
}): {
  fileUrl: string | undefined;
  onDownload: () => Promise<void>;
} => {
  const { form, fileChoice } = args;
  const [fileUrl, setFileUrl] = useState<string | undefined>(undefined);

  // get the file URL when form is chosen
  useEffect(() => {
    async function fetchFormUrl() {
      switch (fileChoice) {
        case PdfFileChoice.PROCESSED:
          setFileUrl(form?.getFilledFormUrl(Cookies.get(SHARED_CONSTANTS.COOKIES.authToken) || "") || undefined)
          break;
        case PdfFileChoice.WATERMARKED:
          // Get Watermarked URL
          if (form?.s3Urls?.watermarkedPdf) {
            setFileUrl(form.s3Urls.watermarkedPdf);
          }
          break;
        case PdfFileChoice.THUMBNAIL:
          // Get Thumbnail URL
          if (form?.s3Urls?.thumbnailFile) {
            setFileUrl(form.s3Urls.thumbnailFile);
          }
          break;
      }
    }
    if (form) {
      fetchFormUrl();
    } else {
      setFileUrl(undefined);
    }
  }, [form, fileChoice]);

  const onDownload = form ? async () => downloadAtticusForm(form) : async () => console.log("no form to download")
  return {
    fileUrl,
    onDownload,
  };
};
